import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import Select, { components } from 'react-select';

import ClearIcon from './clear_filter_icon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';

const Control = props => <components.Control className="form-control select-filter-control" {...props} />;

const NewIndicatorsContainer = () => (
  <div className="left-buffer-md">
    <FontAwesomeIcon icon={faChevronDown}/>
  </div>
);

const IndicatorsContainer = () => (
  <div className="left-buffer-md">
    <span className="caret" />
  </div>
);

const Menu = props => (
  <div className="select-filter-menu" style={{ zIndex: 3 }}>
    <components.Menu {...props} />
  </div>
);

const FixedMenu = props => (
  <div className="select-filter-menu fixed">
    <components.Menu {...props} />
  </div>
);

const MenuList = props => (
  <div className="popover bottom">
    <div className="arrow" />
    <components.MenuList className="w-100" {...props} />
  </div>
);

export function buildSelectContainer(className, newDesignSystem = false) {
  return function Container(props) {
    return (
      <div className={classNames('select-filter-container', className, {
        'ds-filter-button': newDesignSystem,
        'filter-btn btn btn-light': !newDesignSystem
      })}
      >
        <components.SelectContainer {...props} />
      </div>
    );
  };
}


export default class SelectFilter extends React.Component {
  static propTypes = {
    autoWidth: PropTypes.bool,
    componentOverrides: PropTypes.object,
    menuPosition: PropTypes.string,
    name: PropTypes.string,
    newDesignSystem: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    onChange: PropTypes.func.isRequired,
    onClear: PropTypes.func,
  };

  static defaultProps = {
    newDesignSystem: false
  };

  render() {
    const { componentOverrides, newDesignSystem, onClear, ...selectProps } = this.props;
    const indicatorsContainer = newDesignSystem ? NewIndicatorsContainer : IndicatorsContainer;

    let containerClassName = '';
    if (this.props.autoWidth) {
      containerClassName = 'auto-width';
    }
    const SelectContainer = buildSelectContainer(containerClassName, newDesignSystem);

    const components = {
      Control,
      IndicatorsContainer: indicatorsContainer,
      Menu,
      MenuList,
      SelectContainer,
      ...componentOverrides
    };

    if (selectProps.menuPosition === 'fixed') {
      components.Menu = FixedMenu;
    }

    if (onClear) {
      components.IndicatorsContainer = () => <ClearIcon onClear={onClear}/>;
    }

    return (
      <Select
        components={components}
        isSearchable
        {...selectProps}
      />
    );
  }
}
